import type { AxiosInstance } from 'axios';
import axios from 'axios';
import { requestInterceptor } from './request-interceptor';
import { responseErrorInterceptor } from './response-interceptor';

const REQUEST_TIMEOUT = 30_000;
const BASE_URL = import.meta.env.VITE_CRM_APP_API_URL;

export const apiClient: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: REQUEST_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(requestInterceptor, (error) =>
  Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  responseErrorInterceptor
);
